import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { NebulaFormsModule } from '../nebula-forms/nebula-forms.module';
import { NebulaIconsModule } from '../nebula-icons/nebula-icons.module';
import { EntityShortNamePipe } from './entity-shortname-pipe/entity-shortname.pipe';
import { NebulaEmptyListDirective } from './nebula-empty-list.directive';
import { NebulaTableActionsComponent } from './nebula-table-actions/nebula-table-actions.component';
import { NEBULA_PAGINATOR_INTL_PROVIDER } from './paginator/nebula-paginator-intl';

@NgModule({
  imports: [
    CommonModule,
    NebulaIconsModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatMenuModule,
    NebulaFormsModule,
    TranslateModule
  ],
  declarations: [
    EntityShortNamePipe,
    NebulaTableActionsComponent,
    NebulaEmptyListDirective,
  ],
  exports: [
    EntityShortNamePipe,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatMenuModule,
    NebulaTableActionsComponent,
    NebulaEmptyListDirective
  ],
  providers: [
    NEBULA_PAGINATOR_INTL_PROVIDER
  ],
})
export class NebulaTableModule { }
